import { gql } from "@apollo/client";

export const PRE_SIGNED_URL =gql `
query GetUploadSignedUrl($bucketName: String!, $key: String!){
    getUploadSignedUrl(bucketName: $bucketName, key: $key){
      preSignedUrl
      region
    }
  }
`;

export const UPLOAD_PROFILE  = gql`
mutation UpdateUserProfile($emailId: String, $input: user_set_input) {
  update_user(where: {u_email_id: {_eq: $emailId}}, _set: $input) {
    affected_rows
  }
}
`;
